import PromoBuildingCards from '../../PromoBuildingCards/PromoBuildingCards';

const initBuildingIncomeProperty = () => {
  new PromoBuildingCards('income-property');
}

initBuildingIncomeProperty();
